var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-page',[_c('div',{staticClass:"home"},[_c('description-card'),_c('services-card'),_c('testimonials-card'),_c('credentials-card'),_c('contact-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }